import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.div<{ $hovering: boolean }>`
    position: relative;
    align-self: flex-start;
    position: relative;
    top: -8px;
    left: -4px;

    opacity: 0;
    transition: opacity 500ms ease;

    ${({ $hovering }) =>
        $hovering
            ? css`
                  opacity: 1;
                  transition-delay: 600ms;
                  transition: opacity 1s ease;
              `
            : null}

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const LinkButton = styled.button`
    ${styledReset.button}

    width: 28px;
    height: 28px;

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0.5;
    transition: opacity 200ms ease;
    color: #fff;

    &:hover {
        opacity: 1;
    }
`;

export const SuccessToast = styled(motion.div)`
    &&& {
        border: 1px solid #62fa71;
        background-color: #19362c;
        border-radius: 40px;
        z-index: 2;

        @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
            background-color: #62fa711a;
        }

        color: ${({ theme }) => theme.colors.white};
        font-weight: 700;
        font-size: 14px;
        letter-spacing: -0.02em;
        white-space: nowrap;
        line-height: 14px;

        padding: 12px 21px;
        position: absolute;
        top: 50%;
        left: calc(100% + 5px);
        transform: translateY(-50%);
    }
`;
